<template>
    <LoadingComponent :props="loading" />
    <div class="col-12">
        <div class="db-card">
            <div class="db-card-header border-none">
                <h3 class="db-card-title pt-1">{{ $t('menu.stock') }}</h3>
                <div class="db-card-filter">
                    <TableLimitComponent :method="list" :search="props.search" :page="paginationPage" />
                    <FilterComponent @click.prevent="handleSlide('stock-filter')" />
                    <div class="dropdown-group">
                        <ExportComponent />
                        <div class="dropdown-list db-card-filter-dropdown-list">
                            <PrintComponent :props="printObj" />
                            <ExcelComponent :method="xls" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="table-filter-div" id="stock-filter">
                <form class="p-4 sm:p-5 border-t w-full d-block" @submit.prevent="search">
                    <div class="row pt-2">
                        <div class="col-12 sm:col-6 md:col-4 xl:col-3 !pt-0">
                            <label for="searchName" class="db-field-title after:hidden">
                                {{ $t("label.name") }}
                            </label>
                            <input id="searchName" v-model="props.search.product_name" type="text"
                                class="db-field-control" />
                        </div>

                        <div class="col-12 sm:col-6 md:col-4 xl:col-3 !pt-0">
                            <label for="searchStatus" class="db-field-title after:hidden">
                                {{ $t("label.status") }}
                            </label>
                            <vue-select class="db-field-control f-b-custom-select" id="searchStatus"
                                v-model="props.search.status"
                                :options="[{ id: enums.statusEnum.ACTIVE, name: $t('label.active') }, { id: enums.statusEnum.INACTIVE, name: $t('label.inactive') }]"
                                label-by="name" value-by="id" :closeOnSelect="true" :searchable="true" :clearOnClose="true"
                                placeholder="--" search-placeholder="--" />
                        </div>
    
                        <div class="col-12 border-t mt-1">
                            <div class="flex flex-wrap justify-end gap-2">
                                <button class="db-btn py-2 px-3 bg-gray-200" @click.prevent="handleSlide('stock-filter')">
                                    <i class="lab lab-fill-close"></i>
                                </button>
                                <button class="db-btn py-2 bg-gray-200" @click="clear">
                                    <span>{{ $t('button.restore') }}</span>
                                </button>
                                <button class="db-btn py-2 text-white bg-primary">
                                    <span>{{ $t('button.apply_filter') }}</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>

            <div class="db-table-responsive">
                <table class="db-table stripe" id="print">
                    <thead class="db-table-head">
                        <tr class="db-table-head-tr">
                            <th class="db-table-head-th">
                                {{ $t('label.name') }}
                            </th>
                            <th class="db-table-head-th text-center">
                                {{ $t('label.initial_stock') || 'Stock Inicial' }}
                            </th>
                            <th class="db-table-head-th text-center">
                                {{ $t('label.added_stock') || 'Stock Añadido' }}
                            </th>
                            <th class="db-table-head-th text-center">
                                {{ $t('label.sold_stock') || 'Vendido' }}
                            </th>
                            <th class="db-table-head-th text-center font-bold text-primary">
                                {{ $t('label.current_stock') || 'Existencia' }}
                            </th>
                            <th class="db-table-head-th">
                                {{ $t('label.status') }}
                            </th>
                        </tr>
                    </thead>
                    <tbody class="db-table-body" v-if="stocks.length > 0">
                        <tr class="db-table-body-tr" v-for="stock in stocks" :key="stock">
                            <td class="db-table-body-td">
                                {{ textShortener(stock.product_name, 40) }}
                                <span v-if="stock.variation_names"> ( {{ $t('label.variation') }} : {{ stock.variation_names
                                }} )</span>
                            </td>
                            <td class="db-table-body-td text-center text-slate-600 font-medium">
                                {{ stock.initial_stock }}
                            </td>
                            <td class="db-table-body-td text-center text-emerald-600 font-medium">
                                {{ stock.added_stock > 0 ? '+' + stock.added_stock : stock.added_stock }}
                            </td>
                            <td class="db-table-body-td text-center text-rose-500 font-medium">
                                {{ stock.sold_stock > 0 ? '-' + stock.sold_stock : stock.sold_stock }}
                            </td>
                            <td class="db-table-body-td text-center font-bold text-primary">
                                <span class="px-2.5 py-1 rounded-md bg-primary/10">
                                    {{ stock.stock }}
                                </span>
                            </td>
                            <td class="db-table-body-td">
                                <span :class="statusClass(stock.status)">
                                    {{ enums.statusEnumArray[stock.status] }}
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="flex items-center justify-between border-t px-4 py-4">
                <PaginationSMBox :pagination="pagination" :method="list" />
                <div class="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
                    <PaginationTextComponent :props="{ page: paginationPage }" />
                    <PaginationBox :pagination="pagination" :method="list" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import LoadingComponent from "../components/LoadingComponent";
import alertService from "../../../services/alertService";
import statusEnum from "../../../enums/modules/statusEnum";
import PaginationTextComponent from "../components/pagination/PaginationTextComponent";
import PaginationBox from "../components/pagination/PaginationBox";
import PaginationSMBox from "../components/pagination/PaginationSMBox";
import appService from "../../../services/appService";
import TableLimitComponent from "../components/TableLimitComponent";
import SmIconSidebarModalEditComponent from "../components/buttons/SmIconSidebarModalEditComponent";
import SmIconDeleteComponent from "../components/buttons/SmIconDeleteComponent";
import SmIconViewComponent from "../components/buttons/SmIconViewComponent";
import FilterComponent from "../components/buttons/collapse/FilterComponent";
import ExportComponent from "../components/buttons/export/ExportComponent";
import PrintComponent from "../components/buttons/export/PrintComponent";
import ExcelComponent from "../components/buttons/export/ExcelComponent";
import _ from "lodash";

export default {
    name: "StockListComponent",
    components: {
        TableLimitComponent,
        PaginationSMBox,
        PaginationBox,
        PaginationTextComponent,
        LoadingComponent,
        SmIconSidebarModalEditComponent,
        SmIconDeleteComponent,
        SmIconViewComponent,
        FilterComponent,
        ExportComponent,
        PrintComponent,
        ExcelComponent
    },
    data() {
        return {
            loading: {
                isActive: false
            },
            enums: {
                statusEnum: statusEnum,
                statusEnumArray: {
                    [statusEnum.ACTIVE]: this.$t("label.active"),
                    [statusEnum.INACTIVE]: this.$t("label.inactive")
                },
            },
            printLoading: true,
            printObj: {
                id: "print",
                popTitle: this.$t("menu.stock"),
            },
            props: {
                search: {
                    paginate: 1,
                    page: 1,
                    per_page: 10,
                    order_column: 'id',
                    order_type: 'desc',
                    product_name: "",
                    status: null,
                }
            }
        }
    },
    computed: {
        stocks: function () {
            return this.$store.getters['stock/lists'];
        },
        pagination: function () {
            return this.$store.getters['stock/pagination'];
        },
        paginationPage: function () {
            return this.$store.getters['stock/page'];
        },
    },
    mounted() {
        this.list();
    },
    methods: {
        permissionChecker(e) {
            return appService.permissionChecker(e);
        },
        statusClass: function (status) {
            return appService.statusClass(status);
        },
        textShortener: function (text, number = 30) {
            return appService.textShortener(text, number);
        },
        handleSlide: function (id) {
            return appService.handleSlide(id);
        },
        search: function () {
            this.list();
        },
        clear: function () {
            this.props.search.paginate = 1;
            this.props.search.page = 1;
            this.props.search.product_name = "";
            this.props.search.status = null;
            this.list();
        },
        list: function (page = 1) {
            this.loading.isActive = true;
            this.props.search.page = page;
            this.$store.dispatch('stock/lists', this.props.search).then(res => {
                this.loading.isActive = false;
            }).catch((err) => {
                this.loading.isActive = false;
            });
        },
        xls: function () {
            this.loading.isActive = true;
            this.$store.dispatch("stock/export", this.props.search).then((res) => {
                this.loading.isActive = false;
                const blob = new Blob([res.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = this.$t("menu.stock");
                link.click();
                URL.revokeObjectURL(link.href);
            }).catch((err) => {
                this.loading.isActive = false;
                alertService.error(err.response.data.message);
            });
        },
    }
}
</script>

<style scoped>
@media print {
    .hidden-print {
        display: none !important;
    }
}</style>
